import { Injectable } from '@angular/core'
import { HttpClient, HttpResponse } from '@angular/common/http'
import { tap } from 'rxjs/operators'
import { Observable } from 'rxjs'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
import { RegisterStore } from './register.store'
import { RegisterData, RegisterSettings } from './register.model'

@UntilDestroy(this)
@Injectable({ providedIn: 'root' })
export class RegisterService {
  constructor(
    private registerStore: RegisterStore,
    private http: HttpClient,
  ) {}

  register(data: RegisterData): Observable<HttpResponse<null>> {
    return this.http.post<HttpResponse<null>>('./Api/Profile/Register', data)
  }

  getSettings(): void {
    this.http
      .get<RegisterSettings>('./Api/Profile/Register')
      .pipe(
        tap({
          next: settings => {
            this.registerStore.update({ settings })
          },
        }),
        untilDestroyed(this),
      )
      .subscribe()
  }
}
